import { Link } from 'react-router-dom';
import './LandingPage.scss';

const CHROME_STORE_URL = 'https://chromewebstore.google.com/detail/shareqsite/oloccejiekekblplkinfljiogebnhoao';

export function LandingPage() {
  return (
    <div className="landing">
      <section className="landing__hero">
        <div className="landing__hero-inner">
          <span className="landing__badge">Chrome Extension</span>
          <h1 className="landing__title">
            Share HTTP requests<br />
            <span className="landing__title-accent">in one click</span>
          </h1>
          <p className="landing__subtitle">
            Capture network requests from Chrome DevTools, generate shareable
            links with auto-expiration and sensitive header masking — perfect
            for debugging with your team.
          </p>
          <div className="landing__actions">
            <a
              href={CHROME_STORE_URL}
              className="landing__cta landing__cta--primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Install Extension
            </a>
            <Link to="/pricing" className="landing__cta landing__cta--secondary">
              View Pricing
            </Link>
          </div>
        </div>
      </section>

      <section className="landing__features">
        <div className="landing__features-inner">
          <h2 className="landing__section-title">How it works</h2>
          <div className="landing__features-grid">
            <div className="landing__feature">
              <div className="landing__feature-icon">&#9889;</div>
              <h3 className="landing__feature-title">One-Click Capture</h3>
              <p className="landing__feature-desc">
                Select any request in DevTools and share it instantly. Headers,
                body, timing — everything captured in a single click.
              </p>
            </div>
            <div className="landing__feature">
              <div className="landing__feature-icon">&#128274;</div>
              <h3 className="landing__feature-title">Built-in Privacy</h3>
              <p className="landing__feature-desc">
                Sensitive headers like Authorization and Cookies are automatically
                masked. Share safely without leaking credentials.
              </p>
            </div>
            <div className="landing__feature">
              <div className="landing__feature-icon">&#9200;</div>
              <h3 className="landing__feature-title">Auto-Expiring Links</h3>
              <p className="landing__feature-desc">
                Shared requests expire automatically. Choose 1 hour to 7 days
                — no stale links cluttering your channels.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="landing__cta-section">
        <div className="landing__cta-inner">
          <h2 className="landing__cta-title">Stop copy-pasting cURL commands</h2>
          <p className="landing__cta-text">
            Free to use with 5 shares per day. Upgrade to Pro for unlimited
            sharing and batch exports.
          </p>
          <a
            href={CHROME_STORE_URL}
            className="landing__cta landing__cta--primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Started Free
          </a>
        </div>
      </section>
    </div>
  );
}
